const EDITABLE_COMMERCIAL_REQUEST_STATUSES = new Set(["draft", "waiting_customer"]);
const MUTABLE_COMMERCIAL_REQUEST_STATUSES = new Set(["draft", "submitted", "in_review", "waiting_customer"]);

export type CommercialRequestRefreshTarget = "detail" | "list" | "history" | "documents" | "notices";
export type CommercialRequestMutation = "canonicalLink" | "persist" | "upload" | "confirmLocation" | "reviewBillField" | "retryBillExtraction" | "resolveNotice" | "submit" | "officeStatus" | "reassign";

const REFRESH_TARGETS: Record<CommercialRequestMutation, readonly CommercialRequestRefreshTarget[]> = {
  canonicalLink: ["detail", "list", "history"],
  persist: ["list", "history"],
  upload: ["list", "history", "documents", "notices"],
  confirmLocation: ["detail", "list", "history"],
  reviewBillField: ["history", "documents", "notices"],
  retryBillExtraction: ["history", "documents"],
  resolveNotice: ["history", "notices"],
  submit: ["detail", "list", "history"],
  officeStatus: ["detail", "list", "history"],
  reassign: ["detail", "list", "history"],
};

export function canEditCommercialRequestDraft(status: unknown): boolean {
  return EDITABLE_COMMERCIAL_REQUEST_STATUSES.has(String(status));
}

// Mirrors the server's mutation states; accepted, rejected, closed and unknown states fail closed.
export function canMutateCommercialRequestDocuments(status: unknown): boolean {
  return MUTABLE_COMMERCIAL_REQUEST_STATUSES.has(String(status));
}

export function commercialRequestRefreshTargets(mutation: CommercialRequestMutation): readonly CommercialRequestRefreshTarget[] {
  return REFRESH_TARGETS[mutation];
}
